import React, { useState } from 'react';
import "@fontsource/nunito-sans/700.css";
import { Modal } from './Modal';
import { Button } from './Button';
import { NotificationForm } from './NotificationForm';
import { SaveIcon } from './Icons';
import { useNotificationForm } from '../hooks/useNotificationForm';

export const CreateNotificationModal = ({ isOpen, onClose, onSubmit, onSaveDraft }) => {
  const {
    formData,
    updateField,
    togglePlatform,
    setUrgency,
    toggleSchedule,
    resetForm,
    characterCount,
    scheduleError,
  } = useNotificationForm();

  const [wasSubmitted, setWasSubmitted] = useState(false);

  const handleClose = () => {
    setWasSubmitted(false);
    resetForm();
    onClose();
  };

  const handleSubmit = () => {
    setWasSubmitted(true);
    if (scheduleError) return;
    onSubmit(formData);
    handleClose();
  };

  const handleSaveDraft = () => {
    onSaveDraft(formData);
    handleClose();
  };

  const footer = (
    <>
      <Button variant="ghost" onClick={handleClose} className="mr-auto">
        Cancel
      </Button>
      <Button variant="secondary" onClick={handleSaveDraft} icon={<SaveIcon />}>
        Save Draft
      </Button>
      <Button variant="primary" onClick={handleSubmit}>
        Create Notification
      </Button>
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="New Notification"
      footer={footer}
    >
      <NotificationForm
        formData={formData}
        updateField={updateField}
        togglePlatform={togglePlatform}
        setUrgency={setUrgency}
        toggleSchedule={toggleSchedule}
        characterCount={characterCount}
        scheduleError={wasSubmitted ? scheduleError : null}
      />
    </Modal>
  );
};
